import { createTheme } from '@mui/material/styles'
import { red } from '@mui/material/colors'
// import '@fontsource/source-sans-pro'
// eslint-disable-next-line no-restricted-imports
import 'react-toastify/dist/ReactToastify.css'

interface COLOR {
  barBackground: string
  barSecondBackground: string
  barThirdBackground: string
  tooltipBackground: string
  progressBackground: string
  primary: string
  secondary: string
  text: string
  white: string
  dialogHeaderBg: string
  textGrey: {
    [key: number]: string
  }
  blue: {
    [key: number]: string
  }
}

export const colors: COLOR = {
  white: '#ffffff',
  dialogHeaderBg: '#fff',
  textGrey: {
    50: 'rgba(255, 255, 255, 0.5)',
    100: 'rgba(255, 255, 255, 0.2)',
  },
  barBackground: '#4221DE',
  primary: '#FFB900',
  secondary: '#000',
  text: '#000',
  progressBackground: '#805d00',
  barSecondBackground: 'rgba(66, 33, 222, 0.2)',
  tooltipBackground: '#5050A0',
  barThirdBackground: 'rgba(66, 33, 222, 0.8)',
  blue: {
    1: '#5050A0',
    2: 'rgba(80, 80, 160, 0.95)',
    3: 'rgba(80, 80, 160, 0.5)',
    4: 'rgba(80, 80, 160, 0.2)',
  },
}
// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#FFB900',
      dark: 'rgba(0, 255, 10, 0.88)',
      contrastText: '#000',
    },
    secondary: {
      main: '#000',
      dark: 'rgba(255, 255, 255, 0.88)',
      contrastText: '#ffffff',
      50: 'rgba(3, 1, 27, 0.8)',
      100: 'rgba(3, 1, 27, 0.5)',
      200: 'rgba(3, 1, 27, 0.05)',
    },
    error: {
      main: red.A400,
    },
    background: {
      paper: '#fff',
      default: '#000',
    },
    grey: {
      50: 'rgba(255, 255, 255, 0.8)',
      100: 'rgba(255, 255, 255, 0.5)',
      200: 'rgba(255, 255, 255, 0.05)',
      500: 'rgba(255, 255, 255, 0.1)',
      600: 'rgba(255, 255, 255, 0.2)',
    },
  },
})

export default theme
